module.exports = __webpack_public_path__ + "static/media/mahua.e54fec8d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/icons/mahua.png
// module id = 142
// module chunks = 0